import api from 'api';

const getAchievementPageData = async ({ asPath, req }) => {
  try {
    const achievementId = parseInt(asPath.split('/')[3], 10);
    const headers = req ? { Cookie: req.headers.cookie } : {};
    const achievements = await api.get(
      `/admin/achievements?id=${achievementId}&includeAsSupervisor=true`,
      { headers }
    );
    if (
      !achievements.data.achievements ||
      !achievements.data.achievements.length
    ) {
      const error = new Error();
      error.response = { status: 404 };
      throw error;
    }
    return achievements.data.achievements[0];
  } catch (error) {
    return null;
  }
};

export default getAchievementPageData;
